import template from './home.html';

export default {
	template,
	data() {
		return {
			cards: [
				{
					title: 'User Experience',
					desc: 'Learn your visitors\' behavior by using heat maps and videos',
					img: 'play-video.png'
				},
				/*{
					title: 'Audience',
					desc: 'Get to know your audience, learning everything about their habits and needs',
					img: 'table.png'
				},*/
				{
					title: 'Searches',
					desc: 'Reveal the search phrases that bring traffic to your website',
					img: 'diamond.png'
				},
				{
					title: 'Google Bot',
					desc: 'Check how often search bots parse your website',
					img: 'table.png'
				},
				{
					title: 'Referrals',
					desc: 'Stay updated on where your new visitors come from',
					img: 'diamond.png'
				}
			],
			benefits: [
				{
					title: 'Valid data',
					desc: 'Have accurate and up-to-date data on your website traffic and performance at hand. There should be no guessing game when it comes to analytics. Build your strategies on robust data only! ',
				},
				{
					title: 'Heat maps and videos',
					desc: 'Reveal your consumers\' profiles, their behavior, and activities on your site. By tracking their journey, you will improve their experience with your site and boost sales. ',
				},
				{
					title: 'Audience analysis',
					desc: 'Get access to all valuable data, including locations, languages, devices, OS, and browsers your clients use to better understand your audience and get the most out of your promotion campaign. ',
				},
				{
					title: 'Drilling down on event details',
					desc: 'With StatInside, you get relevant data on how much time users spend on your website, which pages they visit, buttons they click, and which ones they ignore.',
				},
				{
					title: 'Bot recognition',
					desc: 'StatInside identifies whether your site is visited by a real visitor or a search bot. You will be updated when the Google bot or any other bot will index your site next time.',
				},
				{
					title: 'Easy-to-use',
					desc: 'Use filters and flexible StatInside settings to have instant access to the most critical data. All your website statistics are just a few clicks away.',
				}
			]
		};
	},
	methods: {
		tryRedirect() {
			if (this.app.user) {
				this.app.navigate(this.app.defaultUrl, true);
			}
		}
	},
	watch: {
		'app.user'() {
			this.tryRedirect();
		}
	},
	mounted() {
		this.tryRedirect();
	}
}